function Salayslip(){
    return(
        <h1>slip</h1>
    )
}
export default Salayslip;